import { useCallback, useState } from 'react'
import type { ComplianceDocumentsLocaleKey } from '@artem-lex/compliance-documents'
import {
  STANDARD_ENTITY_ORIGINAL_VIEW,
  type EntityDisplayLocale,
} from '@/shared/lib/standardEntityLocalizations'

export function resolveEntityDisplayLocale(
  itemId: string,
  localeByItemId: Record<string, ComplianceDocumentsLocaleKey>
): EntityDisplayLocale {
  return localeByItemId[itemId] ?? STANDARD_ENTITY_ORIGINAL_VIEW
}

export function resolveSelectedEntityDisplayLocales(
  itemId: string,
  locale: ComplianceDocumentsLocaleKey,
  previous: Record<string, ComplianceDocumentsLocaleKey>
): Record<string, ComplianceDocumentsLocaleKey> {
  const current = previous[itemId]
  if (current === locale) {
    const updated = { ...previous }
    delete updated[itemId]
    return updated
  }
  return { ...previous, [itemId]: locale }
}

export function useEntityDisplayLocales() {
  const [localeByItemId, setLocaleByItemId] = useState<
    Record<string, ComplianceDocumentsLocaleKey>
  >({})

  const getDisplayLocale = useCallback(
    (itemId: string): EntityDisplayLocale =>
      resolveEntityDisplayLocale(itemId, localeByItemId),
    [localeByItemId]
  )

  const selectItemLocale = useCallback(
    (itemId: string, locale: ComplianceDocumentsLocaleKey) => {
      setLocaleByItemId((previous) =>
        resolveSelectedEntityDisplayLocales(itemId, locale, previous)
      )
    },
    []
  )

  return {
    getDisplayLocale,
    selectItemLocale,
    /** @deprecated Use selectItemLocale */
    toggleItemLocale: selectItemLocale,
  }
}

export { STANDARD_ENTITY_ORIGINAL_VIEW }
